import type { ApiErrorBody } from "../../shared/types.ts";

export class ApiError extends Error {
  constructor(
    public status: number,
    public body: ApiErrorBody,
  ) {
    super(body.error);
  }
}

/** JSON fetch with the CSRF header (ADR-A22). Throws ApiError on non-2xx. */
export async function api<T>(
  path: string,
  init: { method?: "GET" | "POST" | "PUT" | "DELETE"; body?: unknown } = {},
): Promise<T> {
  const res = await fetch(path, {
    method: init.method ?? (init.body !== undefined ? "POST" : "GET"),
    headers: {
      "X-Yabe": "1",
      ...(init.body !== undefined ? { "Content-Type": "application/json" } : {}),
    },
    ...(init.body !== undefined ? { body: JSON.stringify(init.body) } : {}),
    credentials: "same-origin",
  });
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => ({ error: "network" }))) as T & ApiErrorBody;
  if (!res.ok) throw new ApiError(res.status, data);
  return data;
}
